import React from "react";
import PropTypes from "prop-types";
import SearchIcon from "./svg nado/SearchIcon";
import SearchWithAutcomplete from "./SearchWithAutocomplete";

const SearchBlock = (props) => {
    const titelTekst = props.titelTekst;
    const subtitelTekst = props.subtitelTekst;
    const value = props.value;
    const items = props.items;
    const onSearch = props.onSearch;
    const onSelect = props.onSelect;
    const onTextChange = props.onTextChange;
    const onKeyUp = props.onKeyUp;
    const onChangeSelectOption = props.onChangeSelectOption;

    return (
        <div className={'c-search-block c-search-block--small'}>
            <h2 className="c-search-block__title" style={{ textAlign: "center" }}>{titelTekst}</h2>
            <p className="c-search-block__text" style={{ textAlign: "center" }}>{subtitelTekst}</p>
            <div className="c-input c-search-block__input">
                <div className="c-input__wrapper">
                    <SearchWithAutcomplete
                        items={items}
                        value={value}
                        onSearchChange={onTextChange}
                        onResultSelect={onSelect}
                        noResultsMessage={value.length > 1?"Geen resultaten gevonden": ""}
                        minCharacters={3}
                        onKeyUp={onKeyUp}
                        onChangeSelectOption={onChangeSelectOption}
                        />
                    <a href="" className="c-input__button c-search__button" onClick={onSearch} onKeyUp={onSearch} style={{zIndex:999}}>
                        <span className="c-icon c-input__button-icon" aria-hidden="true" focusable="false">
                            <SearchIcon />
                        </span>
                    </a>
                </div>
            </div>
        </div>
    );
};

SearchBlock.defaultProps = {
};

SearchBlock.propTypes = {
    titelTekst: PropTypes.string,
    subtitelTekst: PropTypes.string,
    value: PropTypes.string,
    onSearch: PropTypes.func,
    onSelect: PropTypes.func,
    onTextChange: PropTypes.func,
    items: PropTypes.array,
    onKeyUp: PropTypes.func,
    onChangeSelectOption: PropTypes.func
};

export default SearchBlock;